const baseUrl = 'https://notes.zzzsy.top/'
const uris = {
    'ana-2': `${baseUrl}Ana/ana-2.pdf`,
    'alg-1': `${baseUrl}Alg/alg-1.pdf`,
    'geom-1': `${baseUrl}Geom/geom-1.pdf`,
    'elec-1': `${baseUrl}Elec/elec-1.pdf`,
};

export default uris;